import { Form, Input, Textarea } from '@payaca/ambrosia';
import Button from '@payaca/components/button/Button';
import { ButtonStyleVariant } from '@payaca/components/button/enums';
import MiniLoader from '@payaca/components/miniLoader/MiniLoader';

import TextareaField from '@payaca/components/textareaField/TextareaField';
import { JobLineItemGroupBase } from '@payaca/types/jobContentTypes';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useCallback, useRef, useState, type JSX } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import './ItemGroupHeader.sass';

type Props = {
  canDeleteItemGroup: boolean;
  isDeleting?: boolean;
  itemGroup: JobLineItemGroupBase;
  onDeleteItemGroup?: () => void;
  onUpdateItemGroup: (value: { [key: string]: any }) => void;
  itemGroupExternalUpdateTimestamp?: Date;
};

const ItemGroupHeader: FC<Props> = ({
  canDeleteItemGroup = true,
  isDeleting = false,
  itemGroup,
  onDeleteItemGroup,
  onUpdateItemGroup,
}: Props): JSX.Element => {
  const formMethods = useForm({
    defaultValues: {
      group: {
        description: itemGroup.description,
        isInInputMode: !!itemGroup.description?.length,
      },
    },
  });

  const updateItemGroup = (x: {
    group: {
      description: string;
      isInInputMode: boolean;
    };
  }) => {
    onUpdateItemGroup({
      description: x.group.description,
    });
  };

  return (
    <div className="item-group-header">
      {/* group description */}
      <div className="item-group-header-description">
        <FormProvider {...formMethods}>
          <Controller
            name="group"
            render={({ field: { onChange, value } }) => {
              const show = value.isInInputMode;

              return (
                <>
                  {show && (
                    <TextareaField
                      name="description"
                      value={value.description}
                      placeholder="Item group description"
                      rows={1}
                      onChange={(v) =>
                        onChange({ ...value, description: v.description })
                      }
                      autoSize={true}
                      onBlur={() => {
                        onChange({
                          ...value,
                          isInInputMode: !!value.description?.length,
                        });
                      }}
                      onChangeTimeout={() =>
                        formMethods.handleSubmit(updateItemGroup)()
                      }
                    />
                  )}
                  {!show && (
                    <Button
                      styleVariant={ButtonStyleVariant.ANCHOR}
                      onClick={() =>
                        onChange({
                          ...value,
                          isInInputMode: true,
                        })
                      }
                    >
                      Add group description
                    </Button>
                  )}
                </>
              );
            }}
          />
        </FormProvider>
      </div>
      {canDeleteItemGroup && onDeleteItemGroup && (
        <div className="delete-container">
          {isDeleting ? (
            <MiniLoader />
          ) : (
            <UntitledIcon name="x.3" onClick={onDeleteItemGroup} />
          )}
        </div>
      )}
    </div>
  );
};

export default ItemGroupHeader;
